export const environment = {
  production: true,
  backend: 'https://api.dev.mobilitycompany.it',
  url_sso: 'https://idam.dev.mobilitycompany.it/auth/welcome',
  url_sso_register: 'https://idam.dev.mobilitycompany.it/auth/register',
  url_sso_recovery: 'https://idam.dev.mobilitycompany.it/auth/password-recovery',
  googleMapKey: 'AIzaSyBX0MTym4UtIOQMcHxlmT_hCXBGn1deJRg',
  STRIPE_KEY:
    'pk_test_51IQpmKFvMkoupxOajVrBFQhxxChF3q5aX2LZ9mNoiByi8qQCM7L0PmZ1tRIBvOZO9csNyamOeo7o5mSrqm0HzQov00lsM3WQwC',
  ambient: 'dev',
};
